import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function TrainingView() {
  useDocumentTitle('Training and development-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-27'} title={'Training and Development'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="mb-3 color-border"></div>
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Developing your knowledge, skills, and expertise
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">O</span>ur goal of
                  excellence is centered on placing a big emphasis on ongoing
                  personnel training and development.
                </p>
                <p className="values_p3">
                  Since we view our employees as our most valuable resource, we
                  work to guarantee that you have the knowledge, abilities,
                  self-assurance, and work history necessary to perform your job
                  to the highest standards. All of our healthcare professionals
                  are educated in accordance with national requirements, and we
                  offer facilities and chances for additional training and
                  development, providing you with every chance to advance your
                  career in healthcare.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with-us">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/reward">
                        Reward and Recognition
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/recruitment-process">
                        Recruitment Process
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Our training</h2>
                <p className="white-color">
                  Before you begin working, we provide thorough mandatory
                  training and induction. Our training utilizes a blended
                  learning strategy, combining online theory modules with
                  in-person days that evaluate practical abilities like manual
                  handling, medicine, and basic life support.
                </p>
                <p className="white-color">
                  To help them care for our clients to the greatest standards,
                  we offer specialized training to all of our healthcare
                  personnel. Our initial care plan assessments include
                  identifying the training needs. The needs of our clients will
                  be determined by our registered nurses, along with any
                  clinical treatments that are necessary for you to perform your
                  duties. Our nursing staff, other experts currently involved in
                  our clients' care, or outside licensed professionals may give
                  our specialized training internally. In addition to performing
                  activities on realistic task mannequins, specialized training
                  will include the theory behind problems and therapeutic
                  solutions.
                </p>
                <p className="white-color">
                  The DHSC, NHS, and CQC all recognize the Skills for Care, Care
                  Certificate requirements, to which our training is connected.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Nurse-led service</h2>
                <p className="">
                  Each of our offices is staffed by Registered Nurses. In order
                  to guarantee that we provide the highest possible standards of
                  care delivery, our Registered Nurses take clinical ownership
                  of our care packages. They play a crucial role in training all
                  care staff and certifying their competence in all clinical
                  aspects of the position. They will inform you of national
                  standards and best practice guidelines, and our client's care
                  plan will reflect this for you to follow.
                </p>
                <p>
                  When your preparation is finished, you will actually want to
                  begin shadowing staff on your dispensed bundle/es of care.
                  After that, our registered nurse will begin assisting you in
                  becoming proficient in all aspects of providing client care.
                  This process, which is known as "task delegation," ensures
                  that you receive practical training, observation, and
                  evaluation for the clinical tasks you will be responsible for
                  when working with your client.
                </p>
                <p>The process includes: –</p>
                <div>
                  <ul>
                    <li>
                      Observing tasks and understanding the rationale for
                      undertaking the activity.
                    </li>
                    <li>
                      Involvement in this activity under direct supervision of a
                      Nurse.
                    </li>
                    <li>
                      Performing each activity satisfactorily and in a timely
                      manner without the need for supervision or assistance.
                    </li>
                  </ul>
                </div>
                <p>
                  You would be considered competent to provide care after
                  completing this procedure.
                </p>
                <p>
                  Each clinical procedure you perform for each client you care
                  for will require approval.
                </p>
                <p>
                  {' '}
                  We will keep on offering progressing help, preparing,
                  oversight, and sign off of clinical interventions to guarantee
                  you are completely sure and skillful in every clinical
                  assignment and to recognize any further preparation needs. In
                  order to review and address any issues that arise for both you
                  and your client, peer group meetings will be scheduled.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default TrainingView;
